<app-ez-input cdkOverlayOrigin>
  <input appEzInput
         type="text"
         [formControl]="formControl"
         #input
         (input)="onInputSearch(input.value)"
         (focusin)="onOpenDropDown()"
         autocomplete="none"
  >

  <ng-template appEzRight *ngIf="isLoading">
    <mat-spinner diameter="30" color="accent"></mat-spinner>
  </ng-template>

  <ng-container ezLabel i18n="@@AddresHintLabel">City, street, house number</ng-container>
</app-ez-input>

<ng-template cdkPortal>
  <div class="select-dropdown">
    <div class="select-dropdown__inner">
      <ng-content *ngIf="!input.value || input.value.length < 4 || !hints"></ng-content>

      <ng-container *ngIf="!isLoading && input.value.length >= 4">
        <div class="select-list" *ngIf="hints && hints.length">
          <div class="select-list__item" *ngFor="let hint of hints">
            <button class="select-list__button button button--th-help" (click)="onSelectAddress(hint)">
              <ng-container *ngIf="hint.title && hint.subtitle">
                <div>{{ hint.title }}</div>
                <div class="small">{{ hint.subtitle }}</div>
              </ng-container>
              <ng-container *ngIf="!hint.title || !hint.subtitle">
                {{ hint.value }}
              </ng-container>
            </button>
          </div>
        </div>

        <div class="select-message message h3" *ngIf="hints && hints.length === 0" i18n="@@SelectHintEmpty">
          No results were found for your request
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
